export const WITH_BANNER_CLASSNAME = 'with-banner';
